import { render } from "./loginByTelAndMsgCode_head.vue?vue&type=template&id=8d7e0f96&scoped=true"
import script from "./loginByTelAndMsgCode_head.vue?vue&type=script&lang=js"
export * from "./loginByTelAndMsgCode_head.vue?vue&type=script&lang=js"

import "./loginByTelAndMsgCode_head.vue?vue&type=style&index=0&id=8d7e0f96&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-8d7e0f96"

export default script